// angular
import {Component, OnInit, inject} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
// material angular
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
// components
import {InputComponent} from "@app/core/components/input/input.component";
import {ButtonComponent} from "@app/core/components/button/button.component";
// services
import {WalletService} from "@app/+customer/shared/services/wallet.service";
import {AppToastService} from "@app/shared/services/app-toast.service";
// directives
import {OnlyNumberDirective} from "@app/core/directives/only-number.directive";
import {CommasSeparateNumbersDirective} from "@app/core/directives/commas-separate-numbers.directive";
import {PreventFormSubmitDirective} from "@app/core/directives/form-enter-handler.directive";

@Component({
  selector: "app-credit-cap-dialgo",
  templateUrl: "./credit-cap-dialgo.component.html",
  styleUrls: ["./credit-cap-dialgo.component.scss"],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatCardModule,
    InputComponent,
    MatButtonModule,
    OnlyNumberDirective,
    CommasSeparateNumbersDirective,
    PreventFormSubmitDirective,
    ButtonComponent,
  ],
})
export class CreditCapDialgoComponent implements OnInit {
  public form: FormGroup;
  public isLoading: boolean = false;

  // dependencies
  private _fb = inject(FormBuilder);
  private _walletService = inject(WalletService);
  private _toastService = inject(AppToastService);

  dialogRef = inject<MatDialogRef<CreditCapDialgoComponent>>(MatDialogRef);
  data? = inject(MAT_DIALOG_DATA);

  constructor() {}

  ngOnInit() {
    this._buildForm();
  }

  private _buildForm() {
    this.form = this._fb.group({
      credit_cap: new FormControl(null, Validators.required),
    });
  }

  submit() {
    if (this.form.valid) {
      // prepare form data
      const params = this.form.value;
      params.credit_cap = params.credit_cap.replaceAll(",", "");
      params.credit_cap = parseInt(params.credit_cap);

      // set loading state
      this.isLoading = true;
      this._walletService
        .updateCreditCap(this.data.customerId, params)
        .subscribe({
          next: (res) => {
            this.isLoading = false;
            this._toastService.success(
              "wallet.increaseCreditSuccess",
              "toast.success",
              {
                closeButton: false,
                titleClass: "hidden",
              }
            );
            this.dialogRef.close(res);
          },
          error: () => {
            this.isLoading = false;
            this._toastService.error(
              "wallet.increaseCreditFail",
              "toast.error",
              {
                closeButton: false,
                titleClass: "hidden",
              }
            );
          },
        });
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
